import { __awaiter } from "tslib";
/**
 * 移动端媒体资源统一使用media-service跟local-server交互
 */
import { MediaErrorCode, } from '@tencent/mega-sdk-protocols';
import LocalServer from '../common/local-server-api';
const API_PATH = {
    UPLOAD_IMAGE: '/local-edit/uploadImage',
    DOWNLOAD_IMAGE: '/local-edit/downloadImage',
};
class MegaMediaService {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constructor(transport) {
        this.version = 1;
        this.apis = ['uploadImage', 'downloadImage'];
        this.uploadImage = (options) => __awaiter(this, void 0, void 0, function* () {
            // 上传图片
            try {
                const result = yield this.localServer.post(API_PATH.UPLOAD_IMAGE, options.data, options.params, {
                    'Content-Type': 'multipart/form-data',
                });
                return result;
            }
            catch (err) {
                return {
                    code: MediaErrorCode.ErrorUnknown,
                    message: String(err),
                    data: null,
                };
            }
        });
        this.downloadImage = (options) => __awaiter(this, void 0, void 0, function* () {
            // 下载网络图片转换为本地图片 url
            try {
                const result = yield this.localServer.get(API_PATH.DOWNLOAD_IMAGE, options);
                return result;
            }
            catch (err) {
                return {
                    code: MediaErrorCode.ErrorUnknown,
                    message: String(err),
                    data: null,
                };
            }
        });
        this.localServer = new LocalServer();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isMediaURI(uri) {
        throw new Error('Method not implemented.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getLocationFromMediaURI(uri) {
        throw new Error('Method not implemented.');
    }
}
export default MegaMediaService;
//# sourceMappingURL=mega-media-service.js.map